/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function Interior(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.168 3.16797C15.0962 3.16797 15.9862 3.53698 16.6426 4.19336C17.2989 4.84973 17.668 5.73974 17.668 6.66797V8.36328C17.9963 8.49614 18.2984 8.69391 18.5537 8.94922C19.0537 9.44929 19.335 10.1278 19.335 10.835V15.001C19.3349 15.4871 19.1416 15.9541 18.7979 16.2979C18.4541 16.6415 17.9871 16.835 17.501 16.835H2.50098C2.01504 16.8348 1.54875 16.6414 1.20508 16.2979C0.861338 15.9541 0.668055 15.4871 0.667969 15.001V10.835C0.667969 10.1278 0.949285 9.44929 1.44922 8.94922C1.70452 8.69392 2.00664 8.49613 2.33496 8.36328V6.66797C2.33496 5.73999 2.70337 4.84968 3.35938 4.19336C4.01571 3.53703 4.90677 3.16802 5.83496 3.16797H14.168ZM16.668 10.168C16.4912 10.168 16.3213 10.2383 16.1963 10.3633C16.0715 10.4883 16.001 10.6584 16.001 10.835V11.668C16.0008 12.2201 15.5532 12.668 15.001 12.668H5.00098C4.44904 12.6677 4.00115 12.2199 4.00098 11.668V10.835C4.00098 10.6582 3.93065 10.4883 3.80566 10.3633C3.68073 10.2384 3.51158 10.1681 3.33496 10.168C3.15822 10.168 2.98826 10.2383 2.86328 10.3633C2.73842 10.4883 2.66797 10.6583 2.66797 10.835V14.835H17.335V10.835C17.335 10.6583 17.2645 10.4883 17.1396 10.3633C17.0146 10.2383 16.8448 10.168 16.668 10.168ZM5.83496 5.16797C5.43728 5.16802 5.05566 5.32627 4.77441 5.60742C4.49327 5.8887 4.33496 6.27027 4.33496 6.66797V8.36328C4.66318 8.49613 4.96547 8.69399 5.2207 8.94922C5.68109 9.4098 5.95268 10.0218 5.99316 10.668H9.00098V5.16797H5.83496ZM11.001 10.668H14.0098C14.0503 10.0218 14.3219 9.40979 14.7822 8.94922C15.0375 8.69399 15.3398 8.49613 15.668 8.36328V6.66797C15.668 6.27017 15.5098 5.88872 15.2285 5.60742C14.9472 5.32612 14.5658 5.16797 14.168 5.16797H11.001V10.668Z"
        fill="#35424F"
      />
    </svg>
  )
}

Interior.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Interior
